(() => {
  const SECTION_SELECTOR = '.oddit-section-faq';

  // Open/close is native <details> behaviour — this file only drives the
  // category tabs above the list.
  function initSection(section) {
    const tabs = section.querySelectorAll('.oddit-section-faq__tab');
    for (const tab of tabs) {
      tab.addEventListener('click', handleTabClick);
    }
    if (tabs.length) filterItems(section, tabs[0].getAttribute('data-faq-tab'));
  }

  function filterItems(section, category) {
    const items = section.querySelectorAll('[data-faq-item]');
    for (const item of items) {
      const match = item.getAttribute('data-faq-category') === category;
      item.style.display = match ? '' : 'none';
      if (!match) item.open = false;
    }
  }

  function handleTabClick(e) {
    const clickedTab = e.currentTarget;
    const section = clickedTab.closest(SECTION_SELECTOR);
    const allTabs = section.querySelectorAll('.oddit-section-faq__tab');
    const category = clickedTab.getAttribute('data-faq-tab');

    for (const tab of allTabs) {
      tab.classList.remove('oddit-section-faq__tab--active');
      tab.setAttribute('aria-selected', 'false');
    }

    clickedTab.classList.add('oddit-section-faq__tab--active');
    clickedTab.setAttribute('aria-selected', 'true');
    clickedTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

    const panel = section.querySelector('.oddit-section-faq__accordion-list');
    if (panel) panel.setAttribute('aria-labelledby', clickedTab.id);

    filterItems(section, category);
  }

  function destroySection(section) {
    const tabs = section.querySelectorAll('.oddit-section-faq__tab');
    for (const tab of tabs) {
      tab.removeEventListener('click', handleTabClick);
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
